import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { ProductAnalyticsEvents } from '@grandvisionhq/fun-products';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getAttrValue } from '@grandvisionhq/utils';
import { pushPowerSelectionEvent } from '../../../DataLayer/Mappers/CustomEventMapper.js';
import ProductBlock$1 from '../components/ProductBlock.js';
import { getFacetColor } from '../utils/get-facet-color.js';
import { useCommerceToolsProductData } from '../hooks/use-ct-product-data.js';

const AlgoliaProductBlock = ({ product , additionalUrlParams , onClick , onImpression , className , reimbursableLogos ,  })=>{
    const [activeSku, setActiveSku] = React.useState(product.masterVariant.sku || '');
    const { wasSeen , ref: ref1  } = useWasSeenByUser();
    const { featureConfigs: { unitPriceFixedDecimalsConfig  } = {}  } = useFeatureToggles();
    const handleVariantChange = React.useCallback((sku)=>{
        var ref;
        const productType = (ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name;
        const selectedVariant = product.masterVariant.sku === sku ? product.masterVariant : product.variants.find((variant)=>variant.sku === sku
        );
        if (!selectedVariant) {
            console.error(`Cannot handle variant change if selectedVariant is not found`);
            return;
        }
        if (CommerceToolsApi.isReadyReaders(productType !== null && productType !== void 0 ? productType : '')) {
            const selectedPower = selectedVariant && getAttrValue(selectedVariant, 'power');
            const eventLabel = selectedPower && `${sku} | ${selectedPower}`;
            eventLabel ? pushPowerSelectionEvent('readyreaders', eventLabel) : null;
        }
        const colorFacet = getFacetColor(selectedVariant, productType);
        if (productType && colorFacet) {
            ProductAnalyticsEvents.pushPlpVariantClickEvent({
                type: productType,
                id: product.id,
                name: `${selectedVariant.brand} ${selectedVariant.name}`,
                dimension147: colorFacet
            });
        }
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(()=>{
        if (wasSeen && onImpression) {
            onImpression();
        }
    }, [
        wasSeen
    ]);
    // TODO: in the near future, we want to start stripping the data models we use in algolia (ProductProjectionLight)
    //  to make the records much smaller and improve performance. Then we can start splitting stuff from the CT data resolver.
    const { productType: productType1 , variantInfo , variantUrl , variantImages , otherVariants , promotionLabel , isInsuranceReimbursable ,  } = useCommerceToolsProductData(product, activeSku, additionalUrlParams);
    const isReimbursableFiltered = (additionalUrlParams === null || additionalUrlParams === void 0 ? void 0 : additionalUrlParams.isInsuranceReimbursable) === 'true';
    if (!variantInfo || !variantUrl) {
        console.error('AlgoliaProductBlock: missing critical info required for rendering', {
            variantInfo,
            variantUrl
        });
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductBlock$1, swcHelpers.extends({
        ref: ref1,
        productType: productType1,
        className: className,
        url: variantUrl,
        images: variantImages,
        variants: otherVariants || [],
        promotionLabel: promotionLabel,
        activeSku: activeSku,
        onVariantChange: handleVariantChange,
        onClick: onClick,
        reimbursableLogos: reimbursableLogos,
        isInsuranceReimbursable: isInsuranceReimbursable,
        isReimbursableFiltered: isReimbursableFiltered,
        offering: product.offering,
        pricePerLiterFixedDecimals: unitPriceFixedDecimalsConfig === null || unitPriceFixedDecimalsConfig === void 0 ? void 0 : unitPriceFixedDecimalsConfig.plp
    }, variantInfo));
};
var ProductBlock = AlgoliaProductBlock;

export { AlgoliaProductBlock, ProductBlock as default };
//# sourceMappingURL=Algolia.js.map
